import React from "react";

const PayoutReportTable = ({ reportData, formatMoney }) => {
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="payout-report-table-wrap">
        <table className="payout-report-table">
          <thead>
            <tr>
              <th>Branch</th>
              <th>Code</th>
              <th>Total Payout</th>
              <th>Percent</th>
            </tr>
          </thead>
          <tbody>
            {reportData.map((item) => (
              <tr key={item.id}>
                <td className="payout-report-name-cell">
                  <span
                    className="payout-report-dot"
                    style={{ backgroundColor: item.color }}
                  />
                  <span>{item.shortName || item.name}</span>
                </td>
                <td>{item.shortCode || item.code}</td>
                <td>${formatMoney(item.totalPayout)}</td>
                <td>{item.reportPercent.toFixed(2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return renderBody();
};

export default PayoutReportTable;
